export class NotFound extends Error {
  constructor() {
    super('Não encontrado!');
    this.name = 'NotFound';
  }
}
